import { getMomentTz } from "@dexteel/mesf-core";
import { ColDef, ColGroupDef } from "ag-grid-enterprise";

const moment = getMomentTz();

export const useTableData = () => {
	const columns: ColGroupDef[] = [
		{
			headerName: "Lost Strands",
			children: [
				{
					field: "StrandId",
					headerName: "Strand",
					flex: 1,
					minWidth: 70,
				},
				{
					field: "Timestamp",
					headerName: "Time",
					flex: 1,
					minWidth: 70,
					valueGetter: (p: any) =>
						p.data?.Timestamp ? moment(p.data.Timestamp).format("HH:mm") : "",
					cellStyle: {
						textAlign: "center",
					},
				},
				{
					field: "LostStrandTypeName",
					headerName: "Comment",
					flex: 2,
					minWidth: 100,
					wrapText: true,
					autoHeight: true,
				},
			],
		},
	];

	return { columns };
};
